<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="newyrk"> </p>
<p class="tni"><span class="epub-i">If There Is I Haven’t Found It Yet</span> had its U.S. premiere in New York City on September 20, 2012, at the Laura Pels Theatre of the Harold and Miriam Steinberg Center for Theatre.</p>
<p class="h2"><span class="epub-b">Cast</span></p>
<p class="schar"><span class="epub-sc">GEORGE</span> Brían F. O’Byrne</p>
<p class="schar"><span class="epub-sc">FIONA</span> Michelle Gomez</p>
<p class="schar"><span class="epub-sc">ANNA</span> Annie Funke</p>
<p class="schar"><span class="epub-sc">TERRY</span> Jake Gyllenhaal</p>
<p class="h2"><span class="epub-b">Creative Team</span></p>
<p class="schar"><span class="epub-sc">DIRECTOR</span> Michael Longhurst</p>
<p class="schar"><span class="epub-sc">SETS</span> Beowulf Boritt</p>
<p class="schar"><span class="epub-sc">COSTUMES</span> Susan Hilferty</p>
<p class="schar"><span class="epub-sc">LIGHTS</span> Natasha Katz</p>
<p class="schar"><span class="epub-sc">ORIGINAL MUSIC AND SOUND</span> Obadiah Eaves</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// new-yrk-prod.vue?14dc176e